/**
 * Animation Helpers
 */
export const fadeUpIn = (element) => {
  try {
    element.classList.add('show');
  } catch (error) {
    console.error('\tCLASS: AnimationHelpers\n\tMETHOD: fadeUpIn ', '\n\n', `\t${error}`);
  }
}

export const fadeOut = (element) => {
  // element.style.opacity = 1;
  (function fade() {
    if ((element.style.opacity -= .1) < 0) {
      element.style.display = 'none';
    } else {
      requestAnimationFrame(fade);
    }
  })();
};

export const fadeIn = (element, display?: string) => {
  // element.style.opacity = 0;
  element.style.display = display || "block";
  (function fade() {
    let val = parseFloat(element.style.opacity);
    if (!((val += .1) > 1)) {
      element.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
};